import React from 'react'
import type { RowMembers } from './OtuTableSource.js'

/** A row's drawer once its members are known: until then a loading line, or an error with a retry. */
export function RowDrawer({ members, render }: { members: RowMembers; render: (memberIds: string[]) => React.ReactNode }) {
  if (members.status === 'ready') return <>{render(members.ids)}</>
  if (members.status === 'loading') {
    return (
      <p data-testid="otu-row-drawer-loading" className="text-sm text-gray-500">
        <span className="loading loading-spinner loading-xs mr-2" />
        Loading the OTUs of this row…
      </p>
    )
  }
  return (
    <p data-testid="otu-row-drawer-error" className="text-sm text-error">
      The OTUs of this row could not be loaded.{' '}
      <button className="btn btn-xs btn-outline" onClick={members.retry}>
        Retry
      </button>
    </p>
  )
}
